export const isValuesInArray = (values: string[], target: string[]) => {
    for (const value of values) {
        if (target.includes(value)) {
            return true;
        }
    }

    return false;
};
